export default "__VITE_ASSET__DmGfP2V4__"